// import Icon from '@mdi/react'
import CottageIcon from '@mui/icons-material/Cottage'
import CottageOutlinedIcon from '@mui/icons-material/CottageOutlined'
import { memo } from 'react'

// const svg =
//     'M19,0 L9,10 L11,10 L11,19 L27,19 L27,10 L29,10 L19,0 Z M19,3 L25,9 L25,17 L13,17 L13,9 L19,3 Z'

// const Home = (props) => (
//     <Icon title="Home" path={svg} viewBox={'7 -1 24 24'} size={1} {...props} />
// )

interface HomeProps {
    color?: string
    filled?: boolean
}

const Home = memo(({ color, filled }: HomeProps) => {
    return filled ? (
        <CottageIcon css={{ color: color }} />
    ) : (
        <CottageOutlinedIcon css={{ color: color }} />
    )
})

export default Home
